import { createBrowserRouter } from "react-router";
import DashboardPage from "../pages/dashboard";
import TranscriptionsTranscriptionPage from "../pages/dashboard/[id]";
import TranscriptionsTranscriptionErrorPage from "../pages/dashboard/[id]/error";
import TranscriptionsTranscriptionExportPage from "../pages/dashboard/[id]/export";
import TranscriptionsTranscriptionParticipantsPage from "../pages/dashboard/[id]/participants";
import TranscriptionsTranscriptionTextPage from "../pages/dashboard/[id]/text";
import TranscriptionsCreatePage from "../pages/dashboard/create";

const router = createBrowserRouter([
	{
		path: "/",
		Component: DashboardPage,
		children: [
			{
				index: true,
				Component: TranscriptionsCreatePage,
			},
			{
				path: ":id",
				Component: TranscriptionsTranscriptionPage,
				ErrorBoundary: TranscriptionsTranscriptionErrorPage,
				children: [
					{
						index: true,
						Component: TranscriptionsTranscriptionTextPage,
					},
					{
						path: "participants",
						Component: TranscriptionsTranscriptionParticipantsPage,
					},
					{
						path: "export",
						Component: TranscriptionsTranscriptionExportPage,
					},
				],
			},
		],
	},
]);

export { router };
